import { API_GRAPHQL } from "../../../constants";
import {useState, useEffect} from 'react';
import { axiosAuthFetch } from "../../../helpers/apiActions/authFetch";
//import { getLocalStorageItem } from "../../../helpers/storage";

export function useRetrieveDocumentationGraphQL(id) {
    const url = `${API_GRAPHQL}`;
    const [documentation, setDocumentation] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    //const info = getLocalStorageItem('user');
    //const id = info.user.id;
  
    useEffect(() => {
        async function getDocumentation(url) {
            try {
                setIsLoading(true);
                setIsError(false);
  
                // const response = await fetch(url, {
                //     method: 'POST',
                //     headers: {'Content-Type': 'application/json' },
                //     body: JSON.stringify({
                //       query:`query {
                //         orderedProduct(id:${id}){
                //             data{
                //                 id
                //                 attributes{
                //                     next_service_date
                //                     serial_number
                //                     service_performed_date
                //                     product{
                //                         data{
                //                             id
                //                             attributes{
                //                                 service_form{
                //                                     data{
                //                                         id
                //                                         attributes{
                //                                             service_checks{
                //                                                 data{
                //                                                     id
                //                                                     attributes{
                //                                                         navn
                //                                                         description
                //                                                     }
                //                                                 }
                //                                             }
                //                                         }
                //                                     }
                //                                 }
                //                                 name
                //                                 supplier{
                //                                     data{
                //                                         id
                //                                         attributes{
                //                                             name
                //                                         }
                //                                     }
                //                                 }
                //                                 image{
                //                                     data{
                //                                         attributes{
                //                                             url
                //                                         }
                //                                     }
                //                                 }
                //                             }
                //                         }
                //                     }
                //                     customer{
                //                         data{
                //                             id
                //                             attributes{
                //                                 username
                //                             }
                //                         }
                //                     }
                //                     documentation{
                //                         data{
                //                             id
                //                             attributes{
                //                                 documentation_name
                //                                 documentation_info{
                //                                     year
                //                                     documentation_content{
                //                                         data{
                //                                             id
                //                                             attributes{
                //                                                 url
                //                                             }
                //                                         }
                //                                     }
                //                                     service_images{
                //                                         data{
                //                                             id
                //                                             attributes{
                //                                                 url
                //                                             }
                //                                         }
                //                                     }
                //                                 }
                //                             }
                //                         }
                //                     }
                //                 }
                //             }
                //         }
                //       }`
                //     })
                // });

                const query = `query {
                    orderedProduct(id:${id}){
                        data{
                            id
                            attributes{
                                serial_number
                                historical_documentations{
                                    data{
                                        id
                                        attributes{
                                            name
                                            year
                                            comments
                                            certificates{
                                                data{
                                                    id
                                                    attributes{
                                                        url
                                                    }
                                                }
                                            }
                                            skjemaer{
                                                data{
                                                    id
                                                    attributes{
                                                        url
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                product_delivered_date
                                first_time_delivery
                                executed_services{
                                    data{
                                        id
                                        attributes{
                                            service_info{
                                                date_performed
                                                performed_by{
                                                    data{
                                                        id
                                                        attributes{
                                                            username
                                                        }
                                                    }
                                                }
                                            }
                                            service_checks{
                                                data{
                                                    id
                                                    attributes{
                                                        navn
                                                        description
                                                    }
                                                }
                                            }
                                            service_actions{
                                                data{
                                                    id
                                                    attributes{
                                                        description
                                                        completed
                                                    }
                                                }
                                            }
                                            year
                                            comment
                                            service_info{
                                                date_performed
                                                next_service_date
                                            }
                                        }
                                    }
                                }
                                product{
                                    data{
                                        id
                                        attributes{
                                            service_form{
                                                data{
                                                    id
                                                    attributes{
                                                        service_checks{
                                                            data{
                                                                id
                                                                attributes{
                                                                    navn
                                                                    description
                                                                    category
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            name
                                            varenummer
                                            supplier{
                                                data{
                                                    id
                                                    attributes{
                                                        name
                                                        logo{
                                                            data{
                                                                attributes{
                                                                    url
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            image{
                                                data{
                                                    attributes{
                                                        url
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                customer{
                                    data{
                                        id
                                        attributes{
                                            username
                                        }
                                    }
                                }
                            }
                        }
                    }
                  }`

                const response = await axiosAuthFetch(url, { query }, 'POST')
  
                // const result = await response.json();
                console.log(response);
                setDocumentation(response.data);
            } catch(error) {
                console.error(error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }
  
        getDocumentation(url);
    }, [url, id]);
  
    return {documentation, isLoading, isError};
  }
  
  export default useRetrieveDocumentationGraphQL;